import { Component } from '@angular/core';
import { AssetsGrpcService } from '../../services/AssetsGrpcService';
import { MatSnackBar } from '@angular/material/snack-bar';
// Import from local npm package (resolved via tsconfig paths to ../protolib-js/build)
import { BuildPackResponse, RebuildCorePackResponse } from '@eventsuitemono/protolib/proto/assets_pb';

@Component({
  selector: 'app-resource-packs',
  templateUrl: './resource-packs.component.html',
  styleUrls: ['./resource-packs.component.css']
})
export class ResourcePacksComponent {
  categoriesInput = '';
  description = '';
  loading = false;
  lastResult: { asset?: string; hash?: string } | null = null;

  constructor(private assets: AssetsGrpcService, private snack: MatSnackBar) {}

  parseCategories(): number[] {
    return this.categoriesInput
      .split(',')
      .map((s) => s.trim())
      .filter((s) => s.length > 0)
      .map((s) => Number(s))
      .filter((n) => !isNaN(n));
  }

  async rebuildCore() {
    this.loading = true;
    this.lastResult = null;
    try {
      const res: RebuildCorePackResponse = await this.assets.rebuildCorePack();
      this.lastResult = { asset: res.asset, hash: res.hash };
      this.snack.open('Core pack rebuilt successfully', 'OK', { duration: 3000 });
    } catch (e: any) {
      this.snack.open('Failed to rebuild core pack', 'Dismiss', { duration: 5000 });
    } finally {
      this.loading = false;
    }
  }

  async buildCustom() {
    const cats = this.parseCategories();
    if (cats.length === 0) {
      this.snack.open('Enter at least one category id', 'Dismiss', { duration: 4000 });
      return;
    }
    this.loading = true;
    this.lastResult = null;
    try {
      const res: BuildPackResponse = await this.assets.buildPack(cats, this.description || undefined);
      if (!res.success) throw new Error('failed');
      this.lastResult = { asset: res.asset };
      this.snack.open('Pack built successfully', 'OK', { duration: 3000 });
    } catch (e: any) {
      this.snack.open('Failed to build pack', 'Dismiss', { duration: 5000 });
    } finally {
      this.loading = false;
    }
  }
}
